module.exports = __webpack_public_path__ + "img/sync.d7ad127c.png";